<script>
import background from '../assets/cybermonday/cybermonday-bg.png'
import logoSelma from '../assets/cybermonday/logo-selma-cybermonday.png'
import productsMobile from '../assets/cybermonday/cybermonday-productos-mobile.png'
import productsDesktop from '../assets/cybermonday/cybermonday-productos-desktop.png'
import discountImg from '../assets/cybermonday/cybermonday-descuento.png'
import brandsMobile from '../assets/cybermonday/cybermonday-marcas-mobile.png'
import brandsDesktop from '../assets/cybermonday/cybermonday-marcas-desktop.png'
import sorteoImg from '../assets/cybermonday/cybermonday-sorteo.png'
import logoCyber from '../assets/cybermonday/cybermonday-logo.png'

import countdownMixin from '../mixins/countdown-mixin'

export default {
	mixins: [countdownMixin('hotsale/secondsLeft')],
	metaInfo() {
		return {
			title: 'Hot Sale',
			meta: [{ vmid: 'hs', name: 'description', content: 'Hot Sale' }],
		}
	},
	data() {
		return {
			// images
			background,
			logoSelma,
			productsMobile,
			productsDesktop,
			discountImg,
			brandsMobile,
			sorteoImg,
			logoCyber,
			brandsDesktop,

			showText: false,

			// form
			firstname: '',
			email: '',
			lastname: '',
			birthdate: '',
			activePicker: null,
			category: '',
			modal: false,
			validation: {},
			state: 'pending',
			loading: false,
			loadingCategories: true,
			availableCategories: [],

			minHeight: 377.5,
		}
	},
	mounted() {
		if (!this.secondsLeft) return this.$router.replace('/hotsale')

		this.$nextTick(() => {
			this.$shopApi.get({
				url: '/hotsale-categories',
				loading: (v) => (this.loadingCategories = v),
				onSuccess: ({ data }) => {
					this.availableCategories = data.categories
				},
			})

			const ref = this.$refs.form
			if (!ref) return
			const rect = ref.getBoundingClientRect()
			this.minHeight = rect.height - 24
		})
	},
	methods: {
		async submit() {
			const data = {
				firstname: this.firstname,
				email: this.email,
				lastname: this.lastname,
				birthdate: this.birthdate,
				category: this.category,
			}

			return await this.$shopApi.post({
				url: '/user-forms/hotsale',
				data: { data },
				loading: (v) => {
					this.loading = v
				},
				onSuccess: () => {
					this.state = 'success'
				},
				onError: () => {
					this.state = 'error'
				},
				onValidation: ({ validation }) => (this.validation = validation),
			})
		},
	},
	watch: {
		secondsLeft() {
			if (!this.secondsLeft) return this.$router.replace({ name: 'hotsale' })
		},
	},
	trackPageView: true,
	cssVars: {
		selector: '.shop-app',
	},
	async resolveData(context, to, from, next) {
		const { ssr } = context
		if (ssr) {
			ssr.shouldCache = true
			return {}
		}
	},
}
</script>

<template>
	<div class="container-cybermonday" :class="{ '--desktop': $b.td }">
		<div class="main-container">
			<div class="content w100">
				<div class="__left-side d-flex align-end justify-center">
					<div class="w100">
						<div class="mx-auto d-flex justify-center">
							<div>
								<div class="title-area">
									Es un montón<br />
									<span class="font-weight-bold">por eso lo amamos</span>
								</div>
								<div :class="$bem('timer')" class="mb-2 mb-md-0">
									<div :class="[$bem('__container'), $b.d && $bem('__container--desktop')]">
										<div :class="$bem('__time-unit-container')">
											<div :class="$bem('__digits')">{{ days }}</div>
											<div :class="$bem('__unit')">DIAS</div>
										</div>
										<div class="font-4">:</div>
										<div :class="$bem('__time-unit-container')">
											<div :class="$bem('__digits')">{{ hours }}</div>
											<div :class="$bem('__unit')">HORAS</div>
										</div>
										<div class="font-4">:</div>
										<div :class="$bem('__time-unit-container')">
											<div :class="$bem('__digits')">{{ minutes }}</div>
											<div :class="$bem('__unit')">MINUTOS</div>
										</div>
										<div class="font-4">:</div>
										<div :class="$bem('__time-unit-container')">
											<div :class="$bem('__digits')">{{ seconds }}</div>
											<div :class="$bem('__unit')">SEGUNDOS</div>
										</div>
									</div>
								</div>
								<div class="__text-days font-weight-bold py-7" v-if="$b.m">12, 13 y 14 DE MAYO</div>
							</div>
						</div>
					</div>
				</div>
				<div class="__right-side d-flex align-center w100 justify-center">
					<div>
						<div class="text-center">
							<div class="__text-days" v-if="!$b.m">12, 13 y 14 DE MAYO</div>
							<div class="__text-promo">
								En esta previa a <b>HOT SALE 2025</b>, sumate a la <br />
								comunidad Selma y llevate de regalo un <br />
								calendario imprimible:
							</div>
							<div class="__text-phrase font-weight-bold">
								La grandeza <br />
								de crear un hábito
							</div>
							<div class="__text-subtitle font-weight-bold" v-if="!$b.m">
								31 días, 31 frases y consejos del ciudado personal
							</div>
						</div>
						<div class="form-area">
							<div :class="[$bem('form')]">
								<div
									:class="[$b.m && $bem('__container'), $b.td && $bem('__container--desktop')]"
									class="mx-auto"
								>
									<div class="form__fields">
										<div v-if="state != 'success'" ref="form">
											<div class="form__fields-title">¡Completá con tus datos!</div>
											<div class="form__fields-container">
												<div class="form__fields-group">
													<TextField
														dense
														class="form__field"
														v-model="firstname"
														label="NOMBRE*"
														:error-messages="validation.firstname"
													/>
													<TextField
														dense
														class="form__field"
														v-model="lastname"
														label="APELLIDO*"
														:error-messages="validation.lastname"
													/>
												</div>
												<div class="form__fields-group">
													<TextField
														dense
														class="form__field"
														v-model="email"
														label="MAIL*"
														:error-messages="validation.email"
													/>
													<TextField
														dense
														class="form__field --birthdate"
														v-model="birthdate"
														label="CUMPLEAÑOS*"
														type="date"
														:error-messages="validation.birthdate"
													/>
												</div>
												<div class="form__fields-group">
													<Select
														:menu-props="{ contentClass: 'cybermonday-categories-menu' }"
														:loading="loadingCategories"
														class="form__field form__field--select"
														style="font-family: 'Popins', sans-serif !important"
														background-color="transparent"
														label="CATEGORÍA DE INTERÉS*"
														append-icon="mdi-chevron-down"
														:error-messages="validation.category"
														:items="availableCategories"
														v-model="category"
														color="#2D334F"
														solo
														flat
													/>
												</div>
											</div>
											<Button
												color="#2D334F"
												:class="$bem('__submit-btn')"
												depressed
												:height="$b.m ? '50px' : '65px'"
												:loading="loading"
												@click="submit"
											>
												<div style="position: relative">
													<div class="d-flex align-center">
														<div
															class="__cta-text font-weight-bold"
															style="white-space: nowrap"
														>
															QUIERO TODO
														</div>
														<CyberMonday-Heart class="ml-4" size="25" />
													</div>
												</div>
											</Button>
											<div class="go-to-store">
												<SafeLink :to="$shop.getShopRoute()">VOLVER AL SITIO</SafeLink>
												<CyberMonday-Reload />
											</div>
										</div>
										<div
											v-else
											class="white--text text-center d-flex justify-center align-center"
											:style="{ 'min-height': `${minHeight}px` }"
										>
											<div>
												<div>
													<div class="pt-4 pb-3 font-5">Gracias por Suscribirte</div>
													Pronto te enviaremos todas nuestras ofertas
												</div>
												<div class="go-to-store">
													<SafeLink :to="$shop.getShopRoute()">VOLVER AL SITIO</SafeLink>
													<CyberMonday-Reload />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="w100">
				<div class="mx-auto" style="width: 85%">
					<Media :src="$b.m ? brandsMobile : brandsDesktop" class="brands-image" />
				</div>
				<div class="text-center white--text">
					<div>VER {{ showText ? 'MENOS' : 'MÁS' }}</div>
					<div @click="showText = !showText">
						<CyberMonday-DropDown
							class="dropdown-icon"
							:class="{ 'dropdown-icon--open': showText, 'dropdown-icon--close': !showText }"
						/>
					</div>
				</div>
			</div>
		</div>

		<div
			v-if="showText"
			class="legal-disclaimer text-center mb-8 white--text"
			:class="
				$b.m
					? 'legal-disclaimer--mobile'
					: $b.t
					? 'legal-disclaimer--tablet'
					: 'legal-disclaimer--desktop'
			"
		>
			<div class="mt-2 font-weight-bold">HOT SALE 2025</div>
			<div class="mb-2">
				Conocé las mejores ofertas en dermocosmética, cuidado personal, suplementos, electro belleza y
				salud.
			</div>
			<div class="my-2">
				En Selma Digital te acercamos una selección especial de productos con descuentos imperdibles para
				este Hot Sale 2025, el evento de compras online organizado por CACE (Cámara Argentina de Comercio
				Electrónico), que se realizará del 12 al 14 de mayo en todo el país.
			</div>
			<div>
				Durante esta 11ª edición del Hot Sale, vas a poder acceder a promociones exclusivas en nuestras
				principales categorías: dermocosmética y cuidado personal, con las marcas más reconocidas para el
				cuidado de tu piel y rutina de belleza; fragancias, con perfumes para todos los gustos a precios
				especiales; suplementos, para potenciar tu bienestar y salud desde adentro; electro belleza para
				el día a día, con tecnología aplicada al cuidado del cabello, afeitado, depilación y estética
				personal; y productos de salud esenciales y de primera necesidad, al mejor precio.
			</div>
			<div class="my-2">
				Si estás buscando la combinación perfecta entre cuidado, calidad y ahorro, esta es tu oportunidad.
			</div>
			<div class="mt-2 font-weight-bold">SUSCRIBITE</div>
			<div>
				Sé el primero en enterarte de nuestras ofertas y productos disponibles. Accedé a beneficios
				exclusivos para el Hot Sale en Selma Digital.
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
@mixin font-poppins {
	font-family: 'Poppins', sans-serif;
}

@mixin flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.poppins {
	@include font-poppins;
}

.relative {
	position: relative;
}

.container-cybermonday {
	background: #ff6600;
	color: #fff;
	height: 100%;
	text-align: center;
	@include font-poppins;
}

.__left-side {
	background: url('../assets/cybermonday/cybermonday-bg-mobile-2.jpg');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	min-height: 341px;

	.__text-days {
		letter-spacing: 0.2rem;
	}
}

.go-to-store {
	padding: 28px 0;
}

.brands-image {
	padding: 28px 0;
}

.__right-side {
	.__text-days {
	}
	.__text-promo {
	}
	.__text-phrase {
		padding: 8px 0;
		@include fontSize(4);
		font-weight: bold;
	}
	.__text-subtitle {
		@include fontSize(3);
		line-height: 2.4rem;
	}
}

.title-area {
	font-weight: bold;
	font-size: 18px;
	line-height: 20px;
	span {
		font-size: 25.4px;
	}
}

.timer {
	display: flex;
	justify-content: center;

	&__time-unit-container {
		text-align: center;
		padding: 2px 12px 0px 12px;
		letter-spacing: 0.15rem;
	}

	&__container {
		display: flex;
		align-items: center;
		text-align: center;
		font-weight: bold;
		color: white;

		&--desktop {
			width: 100%;
			max-width: 420px;
			justify-content: space-around;
		}
	}
	&__digits {
		font-size: 2.5rem;
		line-height: 3.1rem;
		font-weight: 600;
	}
	&__unit {
		font-size: 0.7rem;
		line-height: 0.4rem;
	}
}

.form {
	&__fields-title {
		text-align: center;
		font-weight: bold;
		padding: 12px 0 16px 0;
		font-size: 1.3rem;
		line-height: 1.7rem;
	}

	&__fields-group {
		padding: 0 36px;
	}

	&__field {
		padding: 16px 0;
		margin: 16px 0;

		&--select {
			padding: 0;
			border-radius: 100px !important;
			& ::v-deep i.mdi.v-icon {
				color: #2d334f;
			}
		}
	}

	&__submit-btn {
		font-size: 2rem;

		color: #fff !important;
		border-radius: 100px !important;
	}
}

::v-deep label {
	@include font-poppins;
}
::v-deep input {
	@include font-poppins;
	margin-left: 8px;
}
::v-deep input[type='date']::-webkit-calendar-picker-indicator {
	opacity: 0;
}

.--desktop {
	.main-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		height: 100vh;
		background: url('../assets/cybermonday/cybermonday-bg-1.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		.content {
			display: grid;
			grid-template-columns: 1.7fr 1.25fr;
		}
	}

	.brands-image {
		padding: 12px 0;
	}

	.__right-side {
		.__text-days {
			@include fontSize(2);
			letter-spacing: 0.2rem;
			font-weight: bold;
		}
		.__text-promo {
			@include fontSize(2);
		}
		.__text-phrase {
			@include fontSize(7);
		}
		.__text-subtitle {
			@include fontSize(2);
		}
	}

	.go-to-store {
		padding: 4px 0;
	}

	.__left-side {
		background: none;
		min-height: unset;
	}

	.form {
		&__container {
			padding: 16px 0;

			&--tablet {
				max-width: 506px;
			}
		}

		&__fields-title {
			text-align: center;
			font-weight: bold;
			padding: 6px 0;
			font-size: 1.4rem;
			line-height: 1.9rem;
		}

		&__fields-group {
			gap: 12px;
			padding: 0 12px;
			@include flex-center();
		}

		&__field {
			height: 42px;
			padding: 16px 0;
			margin: 16px 0;
			max-width: 265px;
			flex-basis: 50%;
			&--select {
				max-width: 270px;
				flex-basis: unset;
			}
		}

		&__submit-btn {
			margin-top: 4px;
			.__cta-text {
				font-size: 2.2rem;
			}

			color: #fff !important;
			border-radius: 100px !important;
		}
	}

	.timer {
		display: flex;
		justify-content: center;

		&__time-unit-container {
			text-align: center;
			padding: 12px;
		}

		&__container {
			display: flex;
			align-items: center;
			text-align: center;
			font-weight: bold;
			color: white;

			&--desktop {
				width: 100%;
				max-width: 420px;
				justify-content: space-around;
			}
		}
		&__digits {
			font-size: 3.2rem;
			line-height: 3.1rem;
			font-weight: 600;
		}
		&__unit {
			font-size: 0.9rem;
		}
	}

	& .form-area {
		& .form {
			&__submit-btn {
				max-width: 85%;
			}

			&__fields-group {
				margin: 6px 0;
			}

			&__field {
				margin: 4px 0;
				padding: 11px 0;
				&--select {
					margin: 0;
					padding: 0;
				}
			}
		}

		&__close {
			margin-right: 32px;
		}
	}

	& .form__fields-container {
		padding: 0 32px;
	}

	.__cta-text {
		font-size: 2rem;
	}

	@media (width > 1380px) and (height > 800px) {
		.main-container {
			gap: calc(100vh * 0.008);
		}

		.__right-side {
			.__text-days {
				@include fontSize(3);
				letter-spacing: 0.2rem;
				font-weight: bold;
			}
			.__text-promo {
				@include fontSize(3);
				padding: 8px 0;
			}
			.__text-phrase {
				@include fontSize(12);
				font-weight: bold;
			}
			.__text-subtitle {
				@include fontSize(3);
				line-height: 2.4rem;
			}
		}

		.title-area {
			font-weight: bold;
			font-size: 26px;
			line-height: 34px;
			span {
				font-size: 41px;
			}
		}

		.timer {
			&__time-unit-container {
				padding: 8px 0px;
			}

			&__digits {
				font-size: 3.2rem;
				letter-spacing: 0.6rem;
			}
			&__unit {
				line-height: 1.4rem;
			}
		}

		.form {
			&__fields-title {
				@include font-poppins;
				color: white;
				text-align: center;
				font-weight: bold;
				padding: 12px 0 16px 0;
				font-size: 1.2rem;
				line-height: 1.7rem;
			}

			&__fields-group {
				gap: 24px;
				padding: 12px 0;
			}

			.__cta-text {
				font-size: 2.4rem;
			}
		}
	}
}

.cybermonday-categories-menu .v-list {
	@include font-poppins;
	background-color: #fff !important;
	& ::v-deep .v-list-item__title {
		color: #2d334f !important;
	}
}

.go-to-store {
	@include font-poppins;
	text-align: center;
	& a {
		margin-right: 4px;
		color: white !important;
		text-decoration: underline;
	}
}

.dropdown-icon {
	&--open {
		transform: rotate(180deg);
	}
	&--close {
		transform: rotate(0deg);
	}
}

.legal-disclaimer {
	margin: auto;
	&--mobile {
		padding: 0 16px 0 16px;
	}
	&--tablet {
		max-width: 80%;
	}
	&--desktop {
		max-width: 90%;
	}
}

::v-deep .v-input {
	background: #fff;
	border-radius: 145px;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
	border-color: transparent !important;
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:after {
	background-color: transparent !important;
	transform: scale(0) !important;
	-webkit-transform: scale(0) !important;
}
::v-deep .theme--light.v-input input {
	color: #2d334f !important;
}
::v-deep .theme--light.v-label {
	color: #2d334f !important;
	padding-left: 8px;
}

::v-deep .v-text-field__suffix {
	font-size: 13px;
	color: #2d334f !important;
}

::v-deep .v-label {
	width: 100% !important;
	max-width: unset !important;
}
::v-deep .theme--light.v-select .v-select__selections {
	color: #2d334f !important;
}

::v-deep label.v-label.v-label--active {
	left: 15px !important;
	top: 8px;
}
</style>

